import { apiClient } from './apiClient';

export type DashboardChartSlice = {
  label: string;
  value: number;
  count: number;
};

export type DashboardTrendPoint = {
  date: string;
  count: number;
};

export type HomeDashboardCompany = {
  companyName: string;
  legalName?: string;
  planCode?: string;
  licenseStatus: string;
  primaryColor?: string;
  appTitle?: string;
};

export type HomeDashboardOperational = {
  prospectsTotal: number;
  prospectsThisMonth: number;
  prospectsPendingEnrichment: number;
  productsActive: number;
  collaboratorsActive: number;
  campaignsTotal: number;
  opportunitiesTotal: number;
  opportunitiesPipelineValue: number;
  prospectsByCampaign: DashboardChartSlice[];
  prospectsByEnrichmentStatus: DashboardChartSlice[];
  prospectsTrend: DashboardTrendPoint[];
  opportunitiesByStage: DashboardChartSlice[];
};

export type HomeDashboardExecutive = {
  mrr: number;
  arr: number;
  recurringRevenue: number;
  implementationRevenue: number;
  totalWonRevenue: number;
  revenueByProduct: DashboardChartSlice[];
  revenueByProject: DashboardChartSlice[];
  revenueByClient: DashboardChartSlice[];
  revenueBySegment: DashboardChartSlice[];
};

export type HomeDashboard = {
  isExecutiveView: boolean;
  roleCodes: string[];
  company: HomeDashboardCompany;
  operational: HomeDashboardOperational;
  executive?: HomeDashboardExecutive | null;
  generatedAtUtc: string;
};

export async function fetchHomeDashboard(): Promise<HomeDashboard> {
  const response = await apiClient.get<HomeDashboard>('/v1/dashboard');
  return response.data;
}
